// extracted by mini-css-extract-plugin
module.exports = {"addButton":"Tables_addButton__2sXjQ","wrapper":"Tables_wrapper__3NT_R","table":"Tables_table__1oL1-"};